import { accountIdFormat } from "@redotech/redo-account-id";
import { attributeDefinitionIdFormat } from "@redotech/redo-product-id";
import { productMetafieldKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

export const productMetafieldDefinitionSchema = z.object({
  attributeDefinitionId: attributeDefinitionIdFormat.schema,
  namespace: z.string(),
  key: z.string(),
  displayName: z.string(),
});
export type ProductMetafieldDefinition = z.infer<
  typeof productMetafieldDefinitionSchema
>;

export const MAX_PRODUCT_METAFIELD_INSTRUCTIONS_LENGTH = 1000;
export const MAX_PRODUCT_METAFIELD_DISPLAY_NAME_LENGTH = 100;

export const productMetafieldKnowledgeDraftSchema = z.object({
  attributeDefinitionId: attributeDefinitionIdFormat.schema,
  displayName: z
    .string()
    .trim()
    .max(MAX_PRODUCT_METAFIELD_DISPLAY_NAME_LENGTH)
    .nullable(),
  instructions: z
    .string()
    .trim()
    .max(MAX_PRODUCT_METAFIELD_INSTRUCTIONS_LENGTH),
});
export type ProductMetafieldKnowledgeDraft = z.infer<
  typeof productMetafieldKnowledgeDraftSchema
>;

export const productMetafieldKnowledgeSchema = z.object({
  id: productMetafieldKnowledgeIdFormat.schema,
  accountId: accountIdFormat.schema,
  attributeDefinitionId: attributeDefinitionIdFormat.schema,
  namespace: z.string(),
  key: z.string(),
  displayName: z.string().nullable(),
  defaultDisplayName: z.string(),
  instructions: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type ProductMetafieldKnowledge = z.infer<
  typeof productMetafieldKnowledgeSchema
>;
